var searchFinished = function searchFinished(element) {
  return !element || element.tagName === 'BODY';
};

/**
 * Находим ближайший интерактивный dom-элемент
 *   Под интерактивным подразумевается ссылка или кнопка
 */
export var getInteractiveElement = function getInteractiveElement(element) {
  if (searchFinished(element)) return null;
  if (element.tagName.match(/^(A|BUTTON|SUMMARY)$/)) return element;
  if (element.tagName === 'INPUT' && element.type.match(/^button|checkbox$/)) return element;
  return getInteractiveElement(element.parentNode);
};

/**
 * Если текущий элемент является кликабельным, то
 *   Находим самый дальний элемент от которого наследуется это свойство
 */
export var getClickableElement = function getClickableElement(element) {
  var _window, _window$getComputedSt;
  if (searchFinished(element)) return null;
  var isClickable = ((_window = window) === null || _window === void 0 ? void 0 : (_window$getComputedSt = _window.getComputedStyle(element)) === null || _window$getComputedSt === void 0 ? void 0 : _window$getComputedSt.cursor) === 'pointer';
  return isClickable ? getClickableElement(element.parentNode) || element : null;
};
export var getComponentTestId = function getComponentTestId(element) {
  if (searchFinished(element)) return undefined;
  return element.getAttribute('data-t-id') || getComponentTestId(element.parentNode);
};